import axios, { AxiosError } from 'axios';
import { getToken } from '../../components/authentication/functions/authentication_management';
import { emitLicense403 } from '../licensing/license403Bus';
import { getSimulationApiBaseUrl } from '../getAtlasApiBaseUrl';

/**
 * Axios instance for the identity / Atlas auth API (JWT bearer).
 * Attaches Authorization from localStorage and emits license 403s for global UI.
 */
export const atlasAuthApi = axios.create({
  baseURL: getSimulationApiBaseUrl(),
});

atlasAuthApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token?.access_token) {
    config.headers.Authorization = `Bearer ${token.access_token}`;
  }
  return config;
});

function isLicenseDetail(detail: unknown): boolean {
  if (typeof detail !== 'string') return false;
  return detail.toLowerCase().includes('license');
}

atlasAuthApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ detail?: unknown }>) => {
    if (error.response?.status === 403) {
      const detail = error.response.data?.detail;
      if (typeof detail === 'string' && isLicenseDetail(detail)) {
        emitLicense403(detail);
      }
    }
    return Promise.reject(error);
  }
);
